import React, { FC, useState } from "react";

import SMSLogin from "./components/SMSLogin";
import PasswordLogin from "./components/PasswordLogin";
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { loginStore } from "../../store";
import Register from "./components/Register";
import { isZh, Login_Words } from "@/utils/lang";
import { langStore, translate } from "@noli/business";
import { getLang } from "@/router/hook";

const tabSelectedStyle = {
  color: "#4E5969",
  bg: "#fff",
  boxShadow: "1px 1px 4px rgba(0, 0, 0, 0.05)",
};

const tabDefaultStyle = {
  fontSize: "14px",
  fontWeight: "400",
  color: "#86909C",
};

const PhoneLogin: FC = () => {
  const handleTabChang = (index: number) => {
    index ? loginStore.setDialogType("account") : loginStore.setDialogType("phoneCode");
  };
  const lang = langStore.tgt;
  console.log(isZh(), 11111);
  return (
    <Flex flexDir="column" w="100%">
      {isZh() ? (
        <Tabs
          variant="unstyled"
          onChange={handleTabChang}
          defaultIndex={loginStore.dialogType === "phoneCode" ? 0 : 1}
        >
          <TabList bgColor="#F7F8FA" rounded={8} padding={1}>
            <Tab w="50%" py={1} rounded={8} _selected={tabSelectedStyle} {...tabDefaultStyle}>
              {translate(Login_Words.codeAuth, lang)}
            </Tab>
            <Tab py={1} w="50%" rounded={8} _selected={tabSelectedStyle} {...tabDefaultStyle}>
              {translate(Login_Words.accountAuth, lang)}
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel p={0}>
              <SMSLogin />
            </TabPanel>
            <TabPanel p={0}>
              {loginStore.dialogType === "register" ? <Register /> : <PasswordLogin />}
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <>{loginStore.dialogType === "register" ? <Register /> : <PasswordLogin />}</>
      )}
    </Flex>
  );
};

export default observer(PhoneLogin);
